// extracted by mini-css-extract-plugin
export default {"auth":"AuthPage_auth__lgw2P","auth__title":"AuthPage_auth__title__3sPV9","auth__form":"AuthPage_auth__form__mgFGM"};